<template>
	<v-autocomplete
		v-model="model"
		:label="theLabel"
		:required="required"
		:rules="rules"

		v-bind="$attrs"
		:items="items"
		:prepend-icon="icon"
		:item-text="item_text"
		:item-value="item_value"
		@keyup.native="keyup"
	/>
	<!--<v-textarea v-else-->
	<!--v-model="model"-->
	<!--:label="theLabel"-->
	<!--:required="required"-->
	<!--:rules="rules"-->
	<!--v-bind="$attrs">-->
	<!--</v-textarea>-->
</template>

<script>
	export default {
		name: "select-object-autocomplete",
		components: {},
		props: {
			keyup: { type: Function },
			item_text: { type: String },
			item_value: { type: String },
			icon: { type: String },
			items: { type: Array },
			label: { type: String },
			value: {},
			name: { type: String },
			required: { type: Boolean },
			textarea: {
				type: Boolean, default: false,
			},
		},
		data () {
			return {};
		},
		computed: {
			model: {
				get () {
					return this.value;
				},
				set (val) {
					this.$emit("input", val);
				},
			},
			theLabel () {
				return this.required ? this.label + "*" : this.label;
			},
			rules () {
				const rules = [];
				if (this.required) {
					rules.push(v => !!v || `${this.theLabel} הוא שדה חובה`);
				}
				return rules;
			},
		},

	};
</script>

<style scoped>

</style>
